import React, { useEffect, useState } from "react";

const AnimatedSearch = ({
  showSearchInput,
  setShowSearchInput,
  setShowVerticalContainer
}) => {
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [currentWord, setCurrentWord] = useState("");
  const [forward, setForward] = useState(true);

  const handleAnimationContainerClick = () => {
    setShowSearchInput(true);
    setShowVerticalContainer(false);
  };

  useEffect(() => {
    let animationTimeout;
    const words = ["“Frameset”", "“Cockpit”", "“Light”", "“Hydration”"];
    const animate = () => {
      if (forward) {
        animationTimeout = setTimeout(() => {
          setCurrentWord((prevWord) => {
            if (prevWord.length < words[currentWordIndex].length) {
              return prevWord + words[currentWordIndex][prevWord.length];
            } else if (prevWord === words[currentWordIndex]) {
              setTimeout(() => {
                setForward(false);
                setCurrentWordIndex((currentWordIndex + 1) % words.length);
              }, 3000);
              return prevWord;
            } else {
              return prevWord;
            }
          });
        }, 50);
      } else {
        animationTimeout = setTimeout(() => {
          setCurrentWord((prevWord) =>
            prevWord.substring(0, prevWord.length - 1)
          );
          if (currentWord === "") {
            setForward(true);
          } else {
            animate();
          }
        }, 50);
      }
    };

    animate();

    return () => clearTimeout(animationTimeout);
  }, [currentWord, currentWordIndex, forward]);

  return (
    <div
      className="w-full flex items-center justify-start gap-2 px-4 cursor-pointer"
      style={{ display: showSearchInput ? "none" : "flex" }}
      onClick={handleAnimationContainerClick}
    >
      <span className="text-sm font-medium text-gray-400">
        Search for
      </span>
      <span className="text-sm font-semibold text-gray-900 flex items-center">
        {currentWord}
        <b className="ml-1 animate-pulse text-gray-400">|</b>
      </span>
    </div>
  );
};

export default AnimatedSearch;
